"use strict";

const _ = require('lodash');
const GridRowComponent = require("../GridRowComponent");
const Renderer = require("./UnlockedGridRowRenderer");

class UnlockedGridRowComponent extends GridRowComponent {

    constructor(configOptions) {
        super(configOptions);

        this._unlockedColumns = _.difference(this._columnOrder, this._lockedColumns);

        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){
        super._registerListeners();
    }

    _unregisterListeners(){
        super._unregisterListeners();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        return super.shutdown();
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/


    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * Set the column order in the row
     * @param newVal {Array} - An array of strings of column keys representing the order of locked columns
     * @param noEmit {Boolean} - If true, set the data without emitting the event
     * @returns {GridRowComponent}
     */
    setLockedColumns(newVal, noEmit){
        this._lockedColumns = _.concat(newVal,this._rightLockedColumns);
        this._unlockedColumns = _.difference(this._columnOrder, this._lockedColumns);
        if (!noEmit) {
            this.emit('LockedColumns', this._lockedColumns);
        }
        return this;
    }
    getUnlockedColumns(){
        return this._unlockedColumns;
    }

    /**
     * Set the column order in the row
     * @param newVal {Array} - An array of strings of column keys representing the column order in the grid
     * @param noEmit {Boolean} - If true, set the data without emitting the event
     * @returns {GridRowComponent}
     */
    setColumnOrder(newVal, noEmit){
        let isOrderChanged = false;
        newVal.forEach((newColumn, index) => {
            isOrderChanged = isOrderChanged || newColumn !== this._columnOrder[index];
        });
        if (isOrderChanged) {
            this._columnOrder = newVal;
            this._unlockedColumns = _.difference(this._columnOrder, this._lockedColumns);
            if (!noEmit) {
                this.emit('ColumnOrder', this._columnOrder);
            }
        }
        return this;
    }

    setColumnComponents(newVal){
        if (newVal !== this._columnComponents) {
            this._columnComponents = newVal;
            let unlockedColumns = [];
            for (let column in this._columnComponents) {
                let locked = this._columnComponents[column].getLocked();
                let rightLocked = this._columnComponents[column].getLockedRight();
                if (locked === false  && rightLocked === false) {
                    unlockedColumns.push(column);
                }
            }
            this._unlockedColumns = unlockedColumns;
            this.emit('ColumnComponents', this._columnComponents);
        }
        return this;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = UnlockedGridRowComponent;